import { Navigate } from 'react-router-dom';

/** Filing Operations replaced the Workload Planning hub, so its bookmarks land on the new page. */
export const WorkloadPlanningRedirect = () => <Navigate to="/tools/filing-operations" replace />;
